import { FeatureProps } from './types';
import { mapStateToProps as featureToggleDataSelector } from './selectors';
import { AppFeatureName } from '@xarvio/frontend-core-state/lib/featureFlags/utils';
import { useSelector } from 'react-redux';
import { getIsFeatureVisible as getIsBaseFeatureVisible } from '@xarvio/frontend-core-state/lib/featureFlags/utils';
import {
  defaultFeaturesSelector,
  qaFeaturesSelector,
  regionalFeaturesSelector,
  tokenFeaturesSelector,
} from '../../../redux/modules/featureFlags/selectors';
import { getAppStore } from '@xarvio/frontend-core-state/lib/appStoreRef';

export const getIsFeatureVisible = ({
  cropUuid,
  countryCode,
  featureName,
  defaultFeatures,
  regionalFeatures,
  tokenFeatures,
  qaFeatures,
}: FeatureProps): boolean => {
  return getIsBaseFeatureVisible({
    cropUuid,
    countryCode,
    featureName,
    defaultFeatures,
    regionalFeatures,
    tokenFeatures,
    qaFeatures,
  });
};

// isFeatureEnabled can be used in any javascript function that is
// executed after user is loggedin and we have all feature toggle info
export const isFeatureEnabled = (featureName: AppFeatureName) => {
  const store = getAppStore();

  if (!store) {
    throw new Error(
      'App store not initialized. Ensure AppWrapper is mounted before calling isFeatureEnabled.',
    );
  }

  const state = store.getState();
  const {
    defaultFeatures,
    regionalFeatures,
    tokenFeatures,
    qaFeatures,
    countryCode,
  } = featureToggleDataSelector(state);

  return getIsFeatureVisible({
    countryCode,
    featureName,
    defaultFeatures,
    regionalFeatures,
    tokenFeatures,
    qaFeatures,
  });
};

export const useGetIsCountryEnabledToLogin = () => {
  const defaultFeatures = useSelector(defaultFeaturesSelector);
  const regionalFeatures = useSelector(regionalFeaturesSelector);
  const tokenFeatures = useSelector(tokenFeaturesSelector);
  const qaFeatures = useSelector(qaFeaturesSelector);

  return (countryCode: string) => {
    return getIsFeatureVisible({
      countryCode,
      featureName: 'USER_LOGIN',
      defaultFeatures,
      regionalFeatures,
      tokenFeatures,
      qaFeatures,
    });
  };
};
